<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Histórico de Envio de Comprovante</h2>
                    </div>
                </div>
                <div class="panel-body" (window:resize)="onResize($event)">

                    <form [formGroup]="formularioDeEnvioDeComprovante" (ngSubmit)="onSubmit()">

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-5 col-md-5 col-sm-5 col-12">
                                <mat-label>Data Inicial e Final</mat-label>

                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate placeholder="Data Inicial" formControlName="dataInicial">
                                    <input matEndDate placeholder="Data Final" formControlName="dataFinal">
                                </mat-date-range-input>

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                                <mat-error
                                    *ngIf="formularioDeEnvioDeComprovante.controls.dataInicial.hasError('invalidDate') || formularioDeEnvioDeComprovante.controls.dataFinal.hasError('invalidDate')">
                                    Datas inválidas ou com intervalos não permitidos.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-3 col-12">
                                <mat-label>Tipo Envio</mat-label>
                                <mat-select value="Tipo Envio" formControlName="tipoEnvio" name="tipoEnvio"
                                    id="tipoEnvio">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let tipoEnvio of listaTipoEnvio" [value]="tipoEnvio">
                                        {{tipoEnvio}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                                <mat-label>CPF</mat-label>
                                <input matInput value="CPF" class="form-control" id="cpfPaciente" trim="blur"
                                    name="cpfPaciente" formControlName="cpfPaciente" maxlength="14" trim="blur"
                                    nccCpfCnpjMask>
                                <mat-error *ngIf="formularioDeEnvioDeComprovante.controls.cpfPaciente.errors">
                                    O campo CPF está inválido.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                                <mat-label>Nome Paciente</mat-label>
                                <input matInput value="Nome Paciente" class="form-control" id="nomePaciente" trim="blur"
                                    name="nomePaciente" formControlName="nomePaciente" maxlength="60" upperCase>

                                <mat-error
                                    *ngIf="formularioDeEnvioDeComprovante.controls.nomePaciente.hasError('minlength')">
                                    O campo Nome Paciente precisa conter mais do que 2 caracteres.
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                                <mat-label>Celular</mat-label>
                                <input matInput value="Celular" class="form-control" id="celularEnvioPaciente"
                                    name="celularEnvioPaciente" phoneMask [maskInputId]="'celularEnvioPaciente'"
                                    [preValue]="formularioDeEnvioDeComprovante.value.celularEnvioPaciente"
                                    [phoneControl]="formularioDeEnvioDeComprovante.controls['celularEnvioPaciente']"
                                    formControlName="celularEnvioPaciente" minlength="14" maxlength="16">
                                <mat-error *ngIf="formularioDeEnvioDeComprovante.controls.celularEnvioPaciente.errors">
                                    O campo Celular está inválido.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                                <mat-label>Email</mat-label>
                                <input type="email" matInput value="Email" class="form-control" id="emailEnvioPaciente"
                                    trim="blur" name="emailEnvioPaciente" formControlName="emailEnvioPaciente"
                                    maxlength="60">

                                <mat-error
                                    *ngIf="formularioDeEnvioDeComprovante.controls.emailEnvioPaciente.hasError('email')">
                                    Email inválido.
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-6 col-6">
                                <mat-label>Status Envio</mat-label>
                                <mat-select value="Dia" formControlName="envioSucesso" name="envioSucesso"
                                    id="envioSucesso">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let status of listaStatusEnvioComprovante"
                                        [value]="status.codigo">
                                        {{status.descricao}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-6 col-6">
                                <mat-label>Data Nasc.</mat-label>
                                <input matInput [matDatepicker]="dataNascimentoPacienteDP"
                                    formControlName="dataNascimentoPaciente" id="dataNascimentoPaciente"
                                    name="dataNascimentoPaciente">
                                <mat-datepicker-toggle matSuffix [for]="dataNascimentoPacienteDP">
                                </mat-datepicker-toggle>
                                <mat-datepicker #dataNascimentoPacienteDP></mat-datepicker>
                                <mat-error
                                    *ngIf="formularioDeEnvioDeComprovante.controls.dataNascimentoPaciente.hasError('invalidDate')">
                                    O campo Data Nasc. está inválido.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                                <button mat-raised-button color="warn" type="button" matTooltip="Limpar Campos"
                                    style="width: 100%;" (click)="limparCampos()">
                                    Limpar Campos
                                </button>
                            </div>

                            <div class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeEnvioDeComprovante.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                    <ng-container matColumnDef="dataEnvio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Envio </th>
                        <td mat-cell *matCellDef="let envioComprovante"> {{envioComprovante.pk.dataEnvio |
                            date:"dd/MM/yyyy HH:mm:ss"}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sequencial">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Seq. Envio </th>
                        <td mat-cell *matCellDef="let envioComprovante"> {{envioComprovante.pk.sequencial}} </td>
                    </ng-container>

                    <ng-container matColumnDef="tipoEnvio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo Envio </th>
                        <td mat-cell *matCellDef="let envioComprovante"> {{envioComprovante.pk.tipoEnvio}} </td>
                    </ng-container>

                    <ng-container matColumnDef="nomePaciente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Paciente </th>
                        <td mat-cell *matCellDef="let envioComprovante"> {{envioComprovante.nomePaciente}} </td>
                    </ng-container>

                    <ng-container matColumnDef="emailEnvioPaciente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                        <td mat-cell *matCellDef="let envioComprovante"> {{envioComprovante.emailEnvioPaciente}} </td>
                    </ng-container>

                    <ng-container matColumnDef="celularEnvioPaciente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Celular </th>
                        <td mat-cell *matCellDef="let envioComprovante"> {{envioComprovante.celularEnvioPaciente | mask:
                            mascaraFoneCustom(envioComprovante.celularEnvioPaciente)}} </td>
                    </ng-container>

                    <ng-container matColumnDef="envioSucesso">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                        <td mat-cell *matCellDef="let envioComprovante"> {{envioComprovante.envioSucesso | sucessoFalhaPipe}} </td>
                    </ng-container>

                    <ng-container matColumnDef="dscStatusEnvio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Desc. Envio </th>
                        <td mat-cell *matCellDef="let envioComprovante"> {{envioComprovante.dscStatusEnvio}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 30, 50, 70, 100]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
    </div>
</div>